import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { LoadingDialog } from "../../../../../_metronic/_partials/controls";


export function InvoiceOrdersLoadingDialog() {
  const { isLoading: confirmCustomersLoading } = useSelector(
    (state) => ({ isLoading: state.invoiceOrdersConfirmCustomers.listLoading }),
    shallowEqual
  );
  const { isLoading: editAndSendLoading } = useSelector(
    (state) => ({ isLoading: state.invoiceOrdersEditAndSend.listLoading }),
    shallowEqual
  );

  return <LoadingDialog isLoading={confirmCustomersLoading || editAndSendLoading} />;
}
